/* Autoplays product gallery videos (muted, looping) and keeps them playing.
   Dawn's window.pauseAllMedia() pauses every <video> when slides change or a
   modal opens; this resumes our gallery videos whenever they are visible and
   no media lightbox is open. */
(() => {
  if (window.kayameAutoplayInit) return;
  window.kayameAutoplayInit = true;

  const visibility = new WeakMap();

  const shouldPlay = (video) =>
    (visibility.get(video) || 0) > 0.4 && !document.querySelector('product-modal[open]');

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        visibility.set(entry.target, entry.intersectionRatio);
        if (shouldPlay(entry.target)) {
          entry.target.muted = true;
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    },
    { threshold: [0, 0.5] }
  );

  const setup = () => {
    document.querySelectorAll('video.kayame-autoplay-video').forEach((video) => {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.addEventListener('pause', () => {
        setTimeout(() => {
          if (shouldPlay(video)) video.play().catch(() => {});
        }, 150);
      });
      io.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
